import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchMembership, fetchSubscriptionPlans } from "services/api/membership";
import { AuthState } from "slices/auth/reducer";
import { MembershipResponse, MembershipState, PricingResponse } from "types/membership";
import { isFresh } from "utils/helpers";

export const fetchMembershipThunk = createAsyncThunk<{data: MembershipResponse, fetchedAt: number}, {force?: boolean}, {rejectValue: string}>(
    'a/membership',
    async ({force=false}, {rejectWithValue, getState}) => {
        try {
            const state = getState() as {auth: AuthState, membershipState: MembershipState};
            const selectedAgencyId = state.auth.selectedAgencyId;
            const STALE_TIME = apiConfig.FETCH_MEMBERSHIP.staleTime;
            if(!selectedAgencyId) throw new Error("No agency selected!")
            if(!force && isFresh(state.membershipState.membership.last_fetched_at, STALE_TIME)){
                return {data: state.membershipState.membership.data, fetchedAt: state.membershipState.membership.last_fetched_at};
            }
            const response = await fetchMembership(selectedAgencyId);
            return {data: response, fetchedAt: Date.now()};
        } catch (error) {
            return rejectWithValue('Failed to fetch membership!');
        }
    }
)

export const fetchSubscriptionPlansThunk = createAsyncThunk<{data: PricingResponse, fetchedAt: number}, {force?: boolean}, {rejectValue: string}>(
    'a/subscription_plans',
    async ({force=false}, {rejectWithValue, getState}) => {
        try {
            const state = getState() as {auth: AuthState, membershipState: MembershipState};
            const selectedAgencyId = state.auth.selectedAgencyId;
            const STALE_TIME = apiConfig.FETCH_SUBSCRIPTION_PLANS.staleTime;
            if(!selectedAgencyId) throw new Error("No agency selected!")
            if(!force && isFresh(state.membershipState.subscription_plans.last_fetched_at, STALE_TIME)){
                return {data: state.membershipState.subscription_plans.data, fetchedAt: state.membershipState.subscription_plans.last_fetched_at};
            }
            const response = await fetchSubscriptionPlans(selectedAgencyId);
            return {data: response, fetchedAt: Date.now()};
        } catch (error) {
            return rejectWithValue('Failed to fetch subscription plans!');
        }
    }
)
    